import React, { useRef } from "react";
import { Box, Fade, Typography } from "@mui/material";

export const AD_FADE_MS = { enter: 400, exit: 300 };

const PublicAdOverlay = ({ open, ad, tickerPosition = "bottom", items = [] }) => {
  const lastAdRef = useRef(null);
  const lastItemsRef = useRef(items);
  const lastTickerRef = useRef(tickerPosition);

  if (ad?.url) lastAdRef.current = ad;
  if (items?.length) lastItemsRef.current = items;
  if (tickerPosition) lastTickerRef.current = tickerPosition;

  const shownAd = ad?.url ? ad : lastAdRef.current;
  const shownItems = items?.length ? items : lastItemsRef.current;
  const shownTicker = tickerPosition || lastTickerRef.current || "bottom";

  if (!shownAd?.url) return null;

  const ticker = (
    <Box
      sx={{
        flex: "0 0 auto",
        minHeight: { xs: 72, md: 108 },
        backgroundColor: "#183059",
        color: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        gap: 2,
        px: { xs: 2, md: 4 },
        py: 1,
      }}
    >
      {shownItems.map((item) => (
        <Box key={item.label} sx={{ minWidth: 0, textAlign: "center" }}>
          <Typography
            sx={{
              color: "#FFFFFF",
              fontFamily: "Roboto, sans-serif",
              fontWeight: 500,
              fontSize: { xs: "0.85rem", md: "1.25rem" },
              lineHeight: 1.2,
            }}
          >
            {item.label}
          </Typography>
          <Typography
            sx={{
              color: "#F9E719",
              fontFamily: "Roboto, sans-serif",
              fontWeight: 700,
              fontSize: { xs: "1.1rem", md: "2rem" },
              lineHeight: 1.15,
              wordBreak: "break-word",
            }}
          >
            {item.value || "—"}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const media = (
    <Box
      sx={{
        flex: "1 1 auto",
        minHeight: 0,
        backgroundColor: "#111214",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {shownAd.mediaType === "VIDEO" ? (
        <video
          key={shownAd.url}
          src={shownAd.url}
          autoPlay
          muted
          playsInline
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      ) : (
        <img
          src={shownAd.url}
          alt={shownAd.name || "Advertisement"}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      )}
    </Box>
  );

  return (
    <Fade in={Boolean(open)} timeout={AD_FADE_MS} unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 5000,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#111214",
        }}
      >
        {shownTicker === "top" ? ticker : null}
        {media}
        {shownTicker === "bottom" ? ticker : null}
      </Box>
    </Fade>
  );
};

export default PublicAdOverlay;
